import { render, staticRenderFns } from "./BranchContainer.vue?vue&type=template&id=ba459de2&"
import script from "./BranchContainer.vue?vue&type=script&lang=js&"
export * from "./BranchContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports